<div class="container-fluid">
    <div class="row mt-10">
        <div class="col-md-6 title">Notified On</div>
        <div class="col-md-6">{{DateFormatHelper.GetDisplayDate(Instruction.createdOn)}} UTC</div>
    </div>
    <div class="row mt-10">
        <div class="col-md-6 title">Issued From</div>
        <div class="col-md-6">{{DateFormatHelper.GetDisplayDateOnly(Instruction.issuedFrom)}} 00:00 UTC</div>
    </div>
    @if(Instruction.issuedTo){
    <div class="row mt-10">
        <div class="col-md-6 title">Issued To</div>
        <div class="col-md-6">{{(Instruction.issuedTo ? DateFormatHelper.GetDisplayDateOnly(Instruction.issuedTo) + " 00:00 UTC" : "")}}</div>
    </div>
    }
    <div class="row mt-10">
        <div class="col-md-6 title">Date Comments</div>
        <div class="col-md-6">{{Instruction.dateComment}}</div>
    </div>
    <div class="row mt-10">
        <div class="col-md-6 title">Status</div>
        <div class="col-md-6">{{Instruction.status}}
            @if(Instruction.isArchived){
            - Archived
            }
        </div>
    </div>

    @if(Instruction.status == 'New' && UserService.getUser()?.IsTrader){
    <div class="row mt-10">
        <div class="col-md-6"></div>
        <div class="col-md-6"><nj-button size="normal" type="button" [isDisabled]="false" icon=""
                [hasCustomIcon]="false" (buttonClick)="ChangeStatus('Acknowledged')">
                Acknowledge
            </nj-button>
        </div>
    </div>}

    @if(Instruction.status == 'Acknowledged' && UserService.getUser()?.IsTrader){
    <div class="row mt-10">
        <div class="col-md-6"></div>
        <div class="col-md-6"><nj-button size="normal" type="button" [isDisabled]="false" icon=""
                [hasCustomIcon]="false" (buttonClick)="ChangeStatus('Completed')">
                Complete
            </nj-button>
        </div>
    </div>}
    <!-- Archive / UnArchive -->
    @if(UserService.getUser()?.CanArchive)
    {
    <div class="row mt-10">
        <div class="col-md-6"></div>
        <div class="col-md-6">
            <nj-button size="normal" type="button" [isDisabled]="false" icon="" [hasCustomIcon]="false"
                (buttonClick)="ChangeStatus(Instruction.isArchived ? 'UnArchive' : 'Archive')">
                {{ Instruction.isArchived ? 'Unarchive' : 'Archive' }}
            </nj-button>
        </div>
    </div>
    }

    <div class="row title font-weight-bold mt-20">
        Summary
    </div>
    <div class=" row col-md-12" [innerHTML]="Formatext(Instruction.summary)"></div>
    <br/>
    @if (Instruction.instructionType == ResIntructionType.ContinuousMarket) {
    <!--continuous market-->
    <div class="row title font-weight-bold">
        Continuous Market
    </div>
    <div class="row">
        <div class="col-md-12">
            <table id="maxContractEFABlocks" class="nj-table nj-table--hover nj-table--striped nj-cursor">
                <thead>
                    <tr [style]="'background-color: #d8d8d8'">
                        <th class="col-md-3">Market</th>
                        <th class="col-md-1">Direction</th>
                        <th class="col-md-1">Volume</th>
                        <th class="col-md-1">Limit Price</th>
                        <th class="col-md-2">Notes</th>
                        <th class="col-md-2">Execution Strategy</th>
                        <th class="col-md-2">Template</th>
                    </tr>
                </thead>
                <tbody>
                    @for(RCMD of Instruction.continuousMarket; track Instruction.continuousMarket ;let i = $index) {
                    <tr>
                        <td>
                            {{RCMD.product}}
                        </td>
                        <td>
                            {{RCMD.direction}}
                        </td>
                        <td>
                            {{RCMD.volume}}
                        </td>
                        <td>
                            {{RCMD.limitPrice}}
                        </td>
                        <td>
                            {{RCMD.notes}}
                        </td>
                        <td>
                            {{RCMD.executionStrategy}}
                        </td>
                        <td>
                            {{RCMD.template}}
                        </td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>
    </div>
    } 
    @else if (Instruction.instructionType == ResIntructionType.Auction) {

    <!--auction-->
    <div class="row title font-weight-bold">
        Auction
    </div>

    <div class="row mt-10">
        <div class="col-md-6 title">Spread Model</div>
        <div class="col-md-6">{{Instruction.spreadModel == 0 ? "None" : "Spread"}}</div>
    </div>
    <div class="row mt-10">
        <div class="col-md-6 title">Enfor BMUs</div>
        <div class="col-md-6">
        @for(enfor of Instruction.enforBmus; track Instruction.enforBmus; let i = $index)
        {
        {{enfor}}<br />
        }
        </div>
    </div>
    <div class="row">
        - Close
    </div>
     @if (Instruction.closeImage)
    {
        <img [src]="'data:image/png;base64,' + Instruction.closeImage" />
    }
    <div class=" row col-md-12" [innerHTML]="Formatext(Instruction.closeNotes)"></div>
    <div class="row">
        - CO Assumptions
    </div>
     @if (Instruction.coAssumptionsImage)
    {
        <img [src]="'data:image/png;base64,' + Instruction.coAssumptionsImage" />
    }
    <div class=" row col-md-12" [innerHTML]="Formatext(Instruction.coAssumptionsNotes)"></div>
    }
</div>